import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { APP_NAVIGATION } from '../../app.navigation';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { IcsCdkAuthenticator } from '@ics-cdk/authentication';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatCardModule } from '@angular/material/card';

import { NavigationCardComponent } from '../../navigation';
import { NeedsAuthorizationDirective } from '@ics-cdk/core/authorization';
import { IcsContentComponent } from 'ics-core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [
    MatButtonModule,
    RouterLink,
    MatCardModule,
    NavigationCardComponent,
    NeedsAuthorizationDirective,
    IcsContentComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent {
  private readonly _authentication = inject(IcsCdkAuthenticator<any>);

  readonly isAuthenticated = toSignal(this._authentication.isAuthenticated$);

  protected readonly routes = APP_NAVIGATION;
}
